import { DocumentationPageDataV2 } from "./data/documentation-page-v2";
import { DesignElementBase, DesignElementGroupableRequiredPart, DesignElementSlugPart, } from "./base";
import { PageBlockV1 } from "./data";
import { z } from "zod";
export const DocumentationPageV2 = DesignElementBase.extend(DesignElementGroupableRequiredPart.shape)
    .extend(DesignElementSlugPart.shape)
    .extend({
    shortPersistentId: z.string(),
    data: DocumentationPageDataV2.extend({
        oldBlocks: z.array(PageBlockV1).optional(),
    }),
});
